import axiosInstance from 'api/axiosInstance';
import { URL_SCHEDULER_V4_PATROLS_BULK } from 'constants/urls';

/**
 * Create multiple patrols at once via the granular V4 API.
 * Each patrol is created independently — does NOT use full-replacement.
 * Supports partial success (some may fail while others succeed).
 *
 * @param {Array} patrols - Array of patrol objects to create
 * @returns {Promise<Object>} Result with created patrols and any errors
 * @returns {Array} result.created - Successfully created patrol objects
 * @returns {Array} result.errors - Array of { index, error } for failures
 * @returns {number} result.totalCreated
 * @returns {number} result.totalFailed
 */
const bulkCreatePatrols = async (patrols) => {
  const payload = {
    patrols: patrols.map((patrol) => ({
      CustomerId: patrol.CustomerId,
      AddressId: patrol.AddressId,
      ContactId: patrol.ContactId,
      StartTime: patrol.StartTime instanceof Date ? patrol.StartTime.toISOString() : patrol.StartTime,
      EndTime: patrol.EndTime instanceof Date ? patrol.EndTime.toISOString() : patrol.EndTime,
      Type: patrol.Type || 'patrol',
      Checklists: patrol.Checklists || [],
    })),
  };

  const { data } = await axiosInstance({
    method: 'POST',
    url: URL_SCHEDULER_V4_PATROLS_BULK,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    data: payload,
  });

  if (!data.success && !data.data) {
    throw new Error(data.error?.message || 'Failed to create patrols');
  }

  const result = data.data;

  // If there were partial failures, log them but don't throw
  if (result.totalFailed > 0) {
    console.warn(
      `[bulkCreatePatrols] ${result.totalFailed}/${result.totalRequested} patrols failed:`,
      result.errors
    );
  }

  return result;
};

export default bulkCreatePatrols;
